<template lang="pug">
.tabela
    el-table(
        height='calc(100% - 57px)',
        :data='sucursales',
        @sort-change='ordenar'
    )
        el-table-column(
            prop='nome',
            :label='$t("mensagens.usuarios.tabela.nome")',
            min-width='300',
            sortable
        )
        el-table-column(
            prop='documento',
            label='CUIT',
            min-width='300'
        )
            template(slot-scope='scope')
                span {{ formatarCuit(scope.row.documento) }}
        el-table-column(
            prop='ativo',
            label='Status',
            min-width='300',
            sortable
        )
            .template(slot-scope='scope')
                div(
                    :class='[scope.row.ativo ? "verificado" : "nao-verificado"]'
                )
                    | {{ scope.row.ativo ? $t('mensagens.usuarios.tabela.statusUsuario.ativo') : $t('mensagens.usuarios.tabela.statusUsuario.inativo') }}

        template(slot='empty')
            el-empty(
                :description='$t("mensagens.sucursals.emptyTemplate")'
            )

    .py-3.btn-paginacao(style='text-align: center')
        el-pagination(
            background,
            :page-size='20',
            :current-page.sync='paginaLocal.page',
            layout='prev, pager, next',
            :total='totalSucursales',
            @current-change='onPageChange'
        )
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'TabelaSucursales',
    props: {
        sucursales: {
            type: Array,
            default: () => []
        },
        totalSucursales: {
            type: Number,
            default: 0
        },
        pagina: {
            type: Object,
            default: () => ({ page: 1, filter: '' })
        }
    },
    data() {
        return {
            paginaLocal: { ...this.pagina }
        };
    },
    watch: {
        pagina: {
            handler(newVal) {
                this.paginaLocal = { ...newVal };
            },
            deep: true
        }
    },
    methods: {
        ordenar(sortInfo) {
            this.$emit('ordenar', sortInfo);
        },
        abrirModalEditarSucursal(sucursal) {
            this.$emit('abrirModalEditarSucursal', sucursal);
        },
        reenviarEmail(sucursal) {
            this.$emit('reenviarEmail', sucursal);
        },
        acaoAlterarStatus(sucursal) {
            this.$emit('acaoAlterarStatus', sucursal);
        },
        onPageChange(page) {
            this.paginaLocal.page = page;
            this.$emit('changePage', page);
        },
        formatarCuit(cuit) {
          return formatters.formatarCuit(cuit);
        },
        getRoleTraduzido(role) {
            if (role != null) {
                switch (role) {
                    case 'Gestor':
                        return this.$t('mensagens.sucursals.perfil.gestor');
                    case 'Regular':
                        return this.$t('mensagens.sucursals.perfil.regular');
                    case 'Administrador':
                        return this.$t('mensagens.sucursals.perfil.administrador');
                    case 'Assistente':
                        return this.$t('mensagens.sucursals.perfil.assistente');
                    default:
                        return role;
                }
            }
            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    border-radius: 5px;
    overflow: hidden;
    background-color: var(--white);
    height: calc(100vh - 258px);
    width: 100%;
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    .acoes:hover {
        cursor: pointer;
    }
}

.nome {
    em {
        font-size: 12px;
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
        border-radius: 4px;
        padding: 0 4px;
        margin-left: 8px;
    }
}

.verificado,
.nao-verificado,
.ativo,
.inativo {
    border-radius: 20px;
    text-align: center;
    max-width: 120px;
    color: var(--black);
}

.verificado,
.ativo {
    background-color: #d1ead2;
    border: 1px solid #bae0bc;
}

.nao-verificado,
.inativo {
    background-color: #ffaeae;
    border: 1px solid var(--danger);
}

.pagination {
    background-color: var(--white);
    border-radius: 0 0 2px 2px;
    justify-content: center;
}
</style>
